module.exports = __webpack_public_path__ + "static/media/mc.04a4a202.svg";